import React, { useContext } from 'react';
import { Checkbox, makeStyles } from '@material-ui/core';
import { Form, Formik } from 'formik';
import { ClinicInput } from '../UI';
import SubmitButton from '../UI/Buttons/SubmitButton';
import * as yup from 'yup';
import { login } from '../../redux/User/UserAction';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import MessagesContext from '../../contexts/messagesContext';
import { Link } from 'react-router-dom';
import { getClinicId } from '../../utils/storage';
import { PropTypes } from 'prop-types';

const styles = makeStyles({
    // col: {
    //     flex: '1 1 49%'
    // },

    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '5px'
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        display: 'block',
        width: '15px',
        height: '15px',
        borderRadius: '4px',
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")"
    },
    icon: {
        width: '15px',
        height: '15px',
        borderRadius: '4px',
        border: 'solid 1px rgba(27, 144, 250, 0.3)',
        backgroundColor: 'rgba(245, 247, 250, 0.8)'
    },
    text: {
        fontFamily: 'inherit',
        fontSize: '12px',
        fontWeight: 'normal',
        color: '#3d454a',
        opacity: 0.7
    },
    formHeader: {
        fontFamily: 'inherit',
        fontSize: '18px',
        fontWeight: '800',
        color: '#3d454a'
    },
    formMessages: {
        fontFamily: 'inherit',
        fontSize: '14px',
        fontWeight: 'normal',
        color: '#8b8f92',
        lineHeight: 2.5
    },
    field: {
        width: '100%',
        '&:nth-of-type(1)': {
            marginTop: '10px'
        },
        '& label': {
            fontFamily: 'inherit',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#3d454a'
            // margin: '5px 0'
        }
    },
    buttonWrapper: {
        marginTop: '10px'
    }
});
const LoginForm = ({ isTest = false, onSubmit }) => {
    const classes = styles();
    const dispatch = useDispatch();
    const { messages } = useContext(MessagesContext);
    const history = useHistory();
    const clinicId = getClinicId();
    const validation = yup.object({
        username: yup.string().required(messages.login.required),
        password: yup.string().required(messages.login.required)
    });

    return (
        <>
            <Formik
                validationSchema={validation}
                initialValues={{ username: '', password: '' }}
                onSubmit={async (values, { setSubmitting }) => {
                    if (isTest) {
                        await onSubmit(values);
                    } else {
                        setSubmitting(true);
                        await dispatch(login(values)).then((res) => {
                            if (res.status === 200) {
                                if (!clinicId) {
                                    history.push('/select-clinic');
                                } else {
                                    history.push(`/${clinicId}/patients`);
                                }
                            }
                        });
                        setSubmitting(false);
                    }
                }}
            >
                {({ isSubmitting }) => (
                    <Form>
                        <div className={classes.column}>
                            <h2 className={classes.formHeader}>{messages.login.formHeader}</h2>
                            <span className={classes.formMessages}>
                                {messages.login.formMessage}
                            </span>
                            <div className={classes.field}>
                                <ClinicInput
                                    width="100%"
                                    type="text"
                                    name="username"
                                    label={messages.login.username}
                                    placeholder={messages.login.usernamePlaceholder}
                                    bgColor="#f5f7fa"
                                    border="solid 1px #f5f7fa"
                                    dir="auto"
                                />
                            </div>
                            <div className={classes.field}>
                                <ClinicInput
                                    width="100%"
                                    type="password"
                                    name="password"
                                    isPassword
                                    label={messages.login.password}
                                    placeholder={messages.login.passwordPlaceholder}
                                    bgColor="#f5f7fa"
                                    border="solid 1px #f5f7fa"
                                    dir="auto"
                                />
                            </div>
                            <div className={classes.buttonWrapper}>
                                <SubmitButton
                                    isSubmitting={isSubmitting}
                                    fullWith
                                    mr="0"
                                    submitText={messages.login.buttonText}
                                    data-testid="submitBtn"
                                />
                            </div>
                            <div className={classes.row}>
                                <div>
                                    <Checkbox
                                        name="rememberMe"
                                        id="rememberMe"
                                        classes={{ root: classes.checkBox }}
                                        color="primary"
                                        icon={<div className={classes.icon} />}
                                        checkedIcon={<div className={classes.checkedIcon} />}
                                        // checked={checked}
                                    />
                                    <label htmlFor="rememberMe" className={classes.text}>
                                        {messages.login.rememberMe}
                                    </label>
                                </div>
                                <div>
                                    <Link className={classes.text}>
                                        {messages.login.forgetPassword}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
};
LoginForm.propTypes = {
    onSubmit: PropTypes.func,
    isTest: PropTypes.bool
};

export default LoginForm;
